/**
 * SPD-03 / SPD-04 / SPD-07 — defer non-critical Shopify features + yield long work.
 * - Delays Shopify.loadFeatures until cart/search interaction or idle (not on first paint)
 * - Breaks up heavy click work with requestAnimationFrame
 * - Does not remove required cart/checkout behaviour
 */
(function () {
  var PATH = (location.pathname || '');
  var needsCartEarly = /\/(cart|checkouts|account)/.test(PATH);

  function onIdle(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      requestIdleCallback(fn, { timeout: 4000 });
    } else {
      setTimeout(fn, 2000);
    }
  }

  function yieldThen(fn) {
    if (typeof window.scheduler !== 'undefined' && scheduler.yield) {
      scheduler.yield().then(fn);
      return;
    }
    requestAnimationFrame(function () {
      setTimeout(fn, 0);
    });
  }

  /* SPD-03: wrap Shopify.loadFeatures so non-cart pages wait for idle/interaction */
  function patchLoadFeatures() {
    if (!window.Shopify || typeof Shopify.loadFeatures !== 'function') return;
    if (Shopify.__rsLoadFeaturesPatched) return;
    Shopify.__rsLoadFeaturesPatched = true;
    var original = Shopify.loadFeatures.bind(Shopify);
    var queue = [];
    var released = needsCartEarly;

    function flush() {
      released = true;
      while (queue.length) {
        var args = queue.shift();
        try {
          original.apply(null, args);
        } catch (e) {}
      }
    }

    Shopify.loadFeatures = function () {
      var args = arguments;
      if (released) return original.apply(null, args);
      queue.push(args);
      return undefined;
    };

    function release() {
      if (released) return;
      flush();
    }

    ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, release, { once: true, passive: true });
    });
    onIdle(release);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchLoadFeatures);
  } else {
    patchLoadFeatures();
  }
  onIdle(patchLoadFeatures);

  /* SPD-07: expose yield helper for theme ATC handlers */
  window.RSPerf = window.RSPerf || {};
  window.RSPerf.yieldThen = yieldThen;
  window.RSPerf.onIdle = onIdle;

  /* SPD-07: mark after interactive for long custom_liquid scripts that check this */
  onIdle(function () {
    document.documentElement.dataset.rsInteractive = '1';
  });
})();
